import IconMap from "@mui/icons-material/Map";
import { useTranslation } from "react-i18next";

import { useGaiaMap } from "~/modules/map/hooks/useGaiaMap";
import { MAP_STYLE_CONFIG, MAP_STYLE_SATELLITE, MAP_STYLE_STANDARD, MAP_STYLES } from "~/modules/map/mapStyles";

import { MapButton } from "../MapButton";

export function MapButtonToggleBaseMap() {
    const { map } = useGaiaMap();
    const { t } = useTranslation("map");

    const handleToggleStyle = () => {
        const nextStyle =
            map?.getStyle()?.imports?.find(value => value.id === "basemap")?.data?.name === MAP_STYLE_STANDARD
                ? MAP_STYLE_SATELLITE
                : MAP_STYLE_STANDARD;

        // @ts-ignore-next-line mapbox config typing is too strict; we dont want to override too much
        map?.setStyle(MAP_STYLES[nextStyle].styleUrl, { config: MAP_STYLE_CONFIG });
    };

    return <MapButton onClick={handleToggleStyle} icon={<IconMap />} label={t("toggleBaseMap")} />;
}
